<a *ngIf="title" [FCRouterLink]="url" [queryParams]="{scroll: 'sponsored-and-advertised-products'}" [target]="disclaimersTarget">
    <span class="fc-advertised-title" [ngClass]="hasMobile">{{title}}</span>
    <span class="fc-advertised-subTitle">{{subTitle}}</span>
    <span class="fc-advertised-mobileTitle">{{mobileTitle}}</span>
</a>